// src/pages/SellerAccount.js
import React, { useEffect, useState } from 'react';
import API from '../api';
import { Link } from 'react-router-dom';
import { SellerSpinner } from '../components/skeleton';
import '../styles/SellerCommon.css';
import '../styles/SellerAccount.css';

function SellerAccount() {
  const [sellerInfo, setSellerInfo] = useState(null);
  const [userEmail, setUserEmail] = useState('');
  const [loading, setLoading] = useState(true);
  const [editingSection, setEditingSection] = useState(null); // Sezione attualmente in modifica
  const [formData, setFormData] = useState({
    respName: '',
    respLastName: '',
    storeName: '',
    sellerHandle: '',
    storeDescription: '',
    address: '',
    city: '',
    zip: '',
    province: '',
    country: '',
    website: '',
    phone_number: ''
  });
  const [files, setFiles] = useState({
    visuraDoc: null,
    identityDoc: null,
    storeLogoSquare: null,
    storeLogoHorizontal: null,
    storeBanner: null
  });
  const [uploadStatus, setUploadStatus] = useState({
    visuraDoc: { uploading: false, error: null },
    identityDoc: { uploading: false, error: null },
    storeLogoSquare: { uploading: false, error: null },
    storeLogoHorizontal: { uploading: false, error: null },
    storeBanner: { uploading: false, error: null }
  });
  const [deleteStatus, setDeleteStatus] = useState({
    visuraDoc: { deleting: false, error: null },
    identityDoc: { deleting: false, error: null },
    storeLogoSquare: { deleting: false, error: null },
    storeLogoHorizontal: { deleting: false, error: null },
    storeBanner: { deleting: false, error: null }
  });
  const [message, setMessage] = useState('');
  const [passwordMessage, setPasswordMessage] = useState('');
  const [passwordForm, setPasswordForm] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [showPasswordForm, setShowPasswordForm] = useState(false);

  useEffect(() => {
    const fetchSellerInfo = async () => {
      try {
        const res = await API.get('/auth/seller-additional-info');
        if (res.data.success) {
          setSellerInfo(res.data.sellerInfo);
          setUserEmail(res.data.userEmail || '');
          
          if (res.data.sellerInfo) {
            setFormData({
              id: res.data.sellerInfo.id || '',
              user_id: res.data.sellerInfo.user_id || '',
              respName: res.data.sellerInfo.respName || '',
              respLastName: res.data.sellerInfo.respLastName || '',
              storeName: res.data.sellerInfo.storeName || '',
              sellerHandle: res.data.sellerInfo.sellerHandle || '',
              storeDescription: res.data.sellerInfo.storeDescription || '',
              address: res.data.sellerInfo.address || '',
              city: res.data.sellerInfo.city || '',
              zip: res.data.sellerInfo.zip || '',
              province: res.data.sellerInfo.province || '',
              country: res.data.sellerInfo.country || '',
              website: res.data.sellerInfo.website || '',
              phone_number: res.data.sellerInfo.phoneNumber || '',
              storeLogoSquare: res.data.sellerInfo.storeLogoSquare || '',
              storeLogoHorizontal: res.data.sellerInfo.storeLogoHorizontal || '',
              storeBanner: res.data.sellerInfo.storeBanner || '',
            });
          }
        }
      } catch (error) {
        console.error('Errore nel recupero dei dati del venditore:', error);
        setMessage('Errore nel recupero dei dati del venditore.');
      } finally {
        setLoading(false);
      }
    };

    fetchSellerInfo();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (files && files.length > 0) {
      setFiles(prev => ({ ...prev, [name]: files[0] }));
      setUploadStatus(prev => ({ ...prev, [name]: { uploading: false, error: null } }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    try {
      const handleize = (str) => str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      const sellerHandle = `${formData.user_id}-${handleize(formData.storeName)}`;
      
      const data = { ...formData, sellerHandle };
      const res = await API.post('/auth/seller-additional-info', data);

      if (res.data.success) {
        setMessage('Dati aggiornati con successo.');
        setSellerInfo(res.data.sellerInfo);
        setEditingSection(null);
      } else {
        setMessage(res.data.message);
      }
    } catch (error) {
      setMessage(error.response?.data?.message || 'Errore di rete o server');
    }
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswordForm(prev => ({ ...prev, [name]: value }));
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    setPasswordMessage('');

    // Validazioni
    if (passwordForm.newPassword.length < 8) {
      setPasswordMessage('La nuova password deve essere di almeno 8 caratteri.');
      return;
    }

    if (passwordForm.newPassword !== passwordForm.confirmPassword) {
      setPasswordMessage('Le password non coincidono.');
      return;
    }

    try {
      const res = await API.post('/auth/change-password', {
        currentPassword: passwordForm.currentPassword,
        newPassword: passwordForm.newPassword
      });

      if (res.data.success) {
        setPasswordMessage('Password cambiata con successo.');
        setPasswordForm({
          currentPassword: '',
          newPassword: '',
          confirmPassword: ''
        });
        setShowPasswordForm(false);
      } else {
        setPasswordMessage(res.data.message);
      }
    } catch (error) {
      setPasswordMessage(error.response?.data?.message || 'Errore di rete o server');
    }
  };

  // Funzione per caricare un file specifico
  const uploadFile = async (fileType) => {
    if (!files[fileType]) {
      setMessage(`Nessun file selezionato per ${fileType}.`);
      return;
    }

    const formDataToSend = new FormData();
    formDataToSend.append('file', files[fileType]);
    formDataToSend.append('fileType', fileType);

    try {
      setUploadStatus(prev => ({ ...prev, [fileType]: { uploading: true, error: null } }));
      
      const res = await API.post('/auth/upload-file', formDataToSend, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      if (res.data.success) {
        setSellerInfo(prev => ({
          ...prev,
          [fileType]: res.data[fileType] || prev[fileType]
        }));
        setMessage(`${fileType} caricato con successo.`);
        setFiles(prev => ({ ...prev, [fileType]: null }));
      } else {
        setMessage(res.data.message);
        setUploadStatus(prev => ({ ...prev, [fileType]: { uploading: false, error: res.data.message } }));
      }
    } catch (error) {
      setMessage(error.response?.data?.message || 'Errore durante il caricamento del file.');
      setUploadStatus(prev => ({ ...prev, [fileType]: { uploading: false, error: error.response?.data?.message || 'Errore durante il caricamento del file.' } }));
    }
  };

  // Funzione per cancellare un file specifico
  const deleteFile = async (fileType) => {
    try {
      setDeleteStatus(prev => ({ ...prev, [fileType]: { deleting: true, error: null } }));
      
      const res = await API.post('/auth/remove-file', { fileType });

      if (res.data.success) {
        setSellerInfo(prev => ({
          ...prev,
          [fileType]: null
        }));
        setMessage(`${fileType} rimosso con successo.`);
      } else {
        setMessage(res.data.message);
        setDeleteStatus(prev => ({ ...prev, [fileType]: { deleting: false, error: res.data.message } }));
      }
    } catch (error) {
      setMessage(error.response?.data?.message || 'Errore durante la rimozione del file.');
      setDeleteStatus(prev => ({ ...prev, [fileType]: { deleting: false, error: error.response?.data?.message || 'Errore durante la rimozione del file.' } }));
    }
  };

  if (loading) return <SellerSpinner text="Caricamento profilo..." />;

  return (
    <>
      <div className="seller-page-header">
        <div className="seller-page-header-content">
          <div>
            <h1>Profilo</h1>
            <p>Gestisci le informazioni del tuo account e del negozio</p>
          </div>
          {sellerInfo && sellerInfo.sellerHandle && (
            <Link 
              to={`/seller/${sellerInfo.sellerHandle}`} 
              target="_blank"
              className="seller-btn seller-btn-outline"
            >
              Anteprima Negozio
            </Link>
          )}
        </div>
      </div>

      {message && (
        <div className={`seller-message ${message.includes('successo') ? 'success' : 'error'}`}>
          {message}
        </div>
      )}

      {/* Informazioni Personali */}
      <div className="seller-card">
        <div className="seller-card-header">
          <h3>Informazioni Personali</h3>
          <button 
            className="seller-btn seller-btn-secondary seller-btn-sm" 
            onClick={() => setEditingSection(editingSection === 'personal' ? null : 'personal')}
          >
            {editingSection === 'personal' ? 'Annulla' : 'Modifica'}
          </button>
        </div>
        <div className="seller-card-body">
          {editingSection === 'personal' ? (
            <form onSubmit={handleSubmit} className="seller-form">
              <div className="seller-form-group">
                <label className="seller-form-label">Email Account:</label>
                <input
                  type="email"
                  className="seller-form-control"
                  value={userEmail}
                  disabled
                  style={{ backgroundColor: '#f5f5f5', color: '#666' }}
                />
                <small style={{ color: '#666', fontSize: '12px' }}>
                  L'email dell'account non può essere modificata
                </small>
              </div>

              <div className="seller-form-group">
                <label className="seller-form-label">Nome Responsabile:</label>
                <input
                  type="text"
                  className="seller-form-control"
                  name="respName"
                  value={formData.respName}
                  onChange={handleChange}
                  required
                  placeholder="Inserisci il nome del responsabile"
                />
              </div>

              <div className="seller-form-group">
                <label className="seller-form-label">Cognome Responsabile:</label>
                <input
                  type="text"
                  className="seller-form-control"
                  name="respLastName"
                  value={formData.respLastName}
                  onChange={handleChange}
                  required
                  placeholder="Inserisci il cognome del responsabile"
                />
              </div>

              <div className="seller-form-actions">
                <button type="submit" className="seller-btn seller-btn-primary">
                  Salva Modifiche
                </button>
                <button 
                  type="button" 
                  className="seller-btn seller-btn-secondary" 
                  onClick={() => setEditingSection(null)}
                >
                  Annulla
                </button>
              </div>
            </form>
          ) : (
            <div className="seller-info-grid">
              <div className="seller-info-card">
                <div className="seller-info-label">Email Account</div>
                <div className="seller-info-value">{userEmail || 'N/A'}</div>
              </div>
              <div className="seller-info-card">
                <div className="seller-info-label">Nome Responsabile</div>
                <div className="seller-info-value">{sellerInfo.respName || 'N/A'}</div>
              </div>
              <div className="seller-info-card">
                <div className="seller-info-label">Cognome Responsabile</div>
                <div className="seller-info-value">{sellerInfo.respLastName || 'N/A'}</div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Sicurezza Account */}
      <div className="seller-card">
        <div className="seller-card-header">
          <h3>Sicurezza Account</h3>
          <button 
            className="seller-btn seller-btn-secondary seller-btn-sm" 
            onClick={() => setShowPasswordForm(!showPasswordForm)}
          >
            {showPasswordForm ? 'Annulla' : 'Cambia Password'}
          </button>
        </div>
        <div className="seller-card-body">
          {showPasswordForm ? (
            <form onSubmit={handlePasswordSubmit} className="seller-form">
              {passwordMessage && (
                <div className={`seller-message ${passwordMessage.includes('successo') ? 'success' : 'error'}`}>
                  {passwordMessage}
                </div>
              )}
              
              <div className="seller-form-group">
                <label className="seller-form-label">Password Attuale:</label>
                <input
                  type="password"
                  className="seller-form-control"
                  name="currentPassword"
                  value={passwordForm.currentPassword}
                  onChange={handlePasswordChange}
                  required
                  placeholder="Inserisci la password attuale"
                />
              </div>

              <div className="seller-form-group">
                <label className="seller-form-label">Nuova Password:</label>
                <input
                  type="password"
                  className="seller-form-control"
                  name="newPassword"
                  value={passwordForm.newPassword}
                  onChange={handlePasswordChange}
                  required
                  placeholder="Inserisci la nuova password"
                  minLength="8"
                />
                <small style={{ color: '#666', fontSize: '12px' }}>
                  La password deve essere di almeno 8 caratteri
                </small>
              </div>

              <div className="seller-form-group">
                <label className="seller-form-label">Conferma Nuova Password:</label>
                <input
                  type="password"
                  className="seller-form-control"
                  name="confirmPassword"
                  value={passwordForm.confirmPassword}
                  onChange={handlePasswordChange}
                  required
                  placeholder="Conferma la nuova password"
                />
              </div>

              <div className="seller-form-actions">
                <button type="submit" className="seller-btn seller-btn-primary">
                  Cambia Password
                </button>
                <button 
                  type="button" 
                  className="seller-btn seller-btn-secondary" 
                  onClick={() => {
                    setShowPasswordForm(false);
                    setPasswordForm({
                      currentPassword: '',
                      newPassword: '',
                      confirmPassword: ''
                    });
                    setPasswordMessage('');
                  }}
                >
                  Annulla
                </button>
              </div>
            </form>
          ) : (
            <div className="seller-info-grid">
              <div className="seller-info-card">
                <div className="seller-info-label">Password</div>
                <div className="seller-info-value">
                  ••••••••
                  <button 
                    className="seller-btn seller-btn-secondary seller-btn-sm" 
                    onClick={() => setShowPasswordForm(true)}
                    style={{ marginLeft: '10px' }}
                  >
                    Cambia
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      
              {/* Informazioni Negozio */}
        <div className="seller-card">
          <div className="seller-card-header">
            <h3>Informazioni Negozio</h3>
            <button 
              className="seller-btn seller-btn-secondary seller-btn-sm" 
              onClick={() => setEditingSection(editingSection === 'store' ? null : 'store')}
            >
              {editingSection === 'store' ? 'Annulla' : 'Modifica'}
            </button>
          </div>
          <div className="seller-card-body">
            {editingSection === 'store' ? (
              <form onSubmit={handleSubmit} className="seller-form">
                <div className="seller-form-group">
                  <label className="seller-form-label">Nome Negozio:</label>
                  <input
                    type="text"
                    className="seller-form-control"
                    name="storeName"
                    value={formData.storeName}
                    onChange={handleChange}
                    required
                    placeholder="Inserisci il nome del negozio"
                  />
                </div>
                
                <div className="seller-form-group">
                  <label className="seller-form-label">Descrizione Negozio:</label>
                  <textarea
                    className="seller-form-control"
                    name="storeDescription"
                    value={formData.storeDescription}
                    onChange={handleChange}
                    placeholder="Descrivi il tuo negozio"
                    rows="3"
                  />
                </div>
                
                <div className="seller-form-group">
                  <label className="seller-form-label">Indirizzo:</label>
                  <input
                    type="text"
                    className="seller-form-control"
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                    required
                    placeholder="Via/Piazza e numero civico"
                  />
                </div>

                <div className="seller-row">
                  <div className="seller-form-group">
                    <label className="seller-form-label">Città:</label>
                    <input
                      type="text"
                      className="seller-form-control"
                      name="city"
                      value={formData.city}
                      onChange={handleChange}
                      required
                      placeholder="Nome della città"
                    />
                  </div>
                  <div className="seller-form-group">
                    <label className="seller-form-label">CAP:</label>
                    <input
                      type="text"
                      className="seller-form-control"
                      name="zip"
                      value={formData.zip}
                      onChange={handleChange}
                      required
                      placeholder="Codice postale"
                    />
                  </div>
                  <div className="seller-form-group">
                    <label className="seller-form-label">Provincia:</label>
                    <input
                      type="text"
                      className="seller-form-control"
                      name="province"
                      value={formData.province}
                      onChange={handleChange}
                      required
                      placeholder="Sigla provincia"
                    />
                  </div>
                </div>

                <div className="seller-form-group">
                  <label className="seller-form-label">Paese:</label>
                  <input
                    type="text"
                    className="seller-form-control"
                    name="country"
                    value={formData.country}
                    onChange={handleChange}
                    required
                    placeholder="Nome del paese"
                  />
                </div>

                <div className="seller-form-group">
                  <label className="seller-form-label">Sito Web:</label>
                  <input
                    type="url"
                    className="seller-form-control"
                    name="website"
                    value={formData.website}
                    onChange={handleChange}
                    placeholder="https://www.tuo-sito.com"
                  />
                </div>
                
                <div className="seller-form-group">
                  <label className="seller-form-label">Telefono:</label>
                  <input
                    type="text"
                    className="seller-form-control"
                    name="phone_number"
                    value={formData.phone_number}
                    onChange={handleChange}
                    placeholder="Numero di telefono"
                  />
                </div>
                            
                <div className="seller-form-actions">
                  <button type="submit" className="seller-btn seller-btn-primary">
                    Salva Modifiche
                  </button>
                  <button 
                    type="button" 
                    className="seller-btn seller-btn-secondary" 
                    onClick={() => setEditingSection(null)}
                  >
                    Annulla
                  </button>
                </div>
              </form>
            ) : (
              <div className="seller-info-grid">
                <div className="seller-info-card">
                  <div className="seller-info-label">Nome Negozio</div>
                  <div className="seller-info-value">{sellerInfo.storeName || 'N/A'}</div>
                </div>
                <div className="seller-info-card">
                  <div className="seller-info-label">Descrizione Negozio</div>
                  <div className="seller-info-value">{sellerInfo.storeDescription || 'N/A'}</div>
                </div>
                <div className="seller-info-card">
                  <div className="seller-info-label">Indirizzo</div>
                  <div className="seller-info-value">{sellerInfo.address || 'N/A'}</div>
                </div>
                <div className="seller-info-card">
                  <div className="seller-info-label">Città</div>
                  <div className="seller-info-value">{sellerInfo.city || 'N/A'}</div>
                </div>
                <div className="seller-info-card">
                  <div className="seller-info-label">CAP</div>
                  <div className="seller-info-value">{sellerInfo.zip || 'N/A'}</div>
                </div>
                <div className="seller-info-card">
                  <div className="seller-info-label">Provincia</div>
                  <div className="seller-info-value">{sellerInfo.province || 'N/A'}</div>
                </div>
                <div className="seller-info-card">
                  <div className="seller-info-label">Paese</div>
                  <div className="seller-info-value">{sellerInfo.country || 'N/A'}</div>
                </div>
                <div className="seller-info-card">
                  <div className="seller-info-label">Sito Web</div>
                  <div className="seller-info-value">
                    {sellerInfo.website ? (
                      <a href={sellerInfo.website} target="_blank" rel="noopener noreferrer">
                        {sellerInfo.website}
                      </a>
                    ) : 'N/A'}
                  </div>
                </div>
                <div className="seller-info-card">
                  <div className="seller-info-label">Telefono</div>
                  <div className="seller-info-value">{sellerInfo.phoneNumber || 'N/A'}</div>
                </div>
              </div>
            )}
          </div>
        </div>
              {/* Immagini */}
        <div className="seller-card">
          <div className="seller-card-header">
            <h3>Immagini Negozio</h3>
            <button 
              className="seller-btn seller-btn-secondary seller-btn-sm" 
              onClick={() => setEditingSection(editingSection === 'images' ? null : 'images')}
            >
              {editingSection === 'images' ? 'Annulla' : 'Modifica'}
            </button>
          </div>
          <div className="seller-card-body">
            {editingSection === 'images' ? (
              <form className="seller-form">
                {/* Logo Negozio Quadrato */}
                <div className="seller-form-group">
                  <label className="seller-form-label">Logo Negozio Quadrato:</label>
                  <div className="seller-file-upload">
                    <input
                      type="file"
                      className="seller-form-control"
                      name="storeLogoSquare"
                      accept="image/*,application/pdf"
                      onChange={handleFileChange}
                    />
                    <p style={{ margin: '8px 0 0 0', fontSize: '12px', color: '#666' }}>
                      Formati supportati: JPG, PNG, PDF. Dimensione massima: 5MB
                    </p>
                  </div>
                  {files.storeLogoSquare && (
                    <button
                      type="button"
                      className="seller-btn seller-btn-secondary"
                      onClick={() => uploadFile('storeLogoSquare')}
                      disabled={uploadStatus.storeLogoSquare.uploading}
                    >
                      {uploadStatus.storeLogoSquare.uploading ? '⏳ Caricamento...' : '📤 Carica Logo Quadrato'}
                    </button>
                  )}
                  {uploadStatus.storeLogoSquare.error && (
                    <div className="seller-text-danger">{uploadStatus.storeLogoSquare.error}</div>
                  )}
                  {sellerInfo.storeLogoSquare && (
                    <div className="seller-file-preview">
                      {sellerInfo.storeLogoSquare.endsWith('.pdf') ? (
                        <a href={sellerInfo.storeLogoSquare} target="_blank" rel="noopener noreferrer" className="seller-btn seller-btn-outline">
                          📄 Visualizza Logo Quadrato
                        </a>
                      ) : (
                        <img src={sellerInfo.storeLogoSquare} alt="Logo Quadrato" />
                      )}
                      <div className="seller-file-actions">
                        <button
                          type="button"
                          className="seller-btn seller-btn-danger seller-btn-sm"
                          onClick={() => deleteFile('storeLogoSquare')}
                          disabled={deleteStatus.storeLogoSquare.deleting}
                        >
                          {deleteStatus.storeLogoSquare.deleting ? '⏳ Rimuovendo...' : '🗑️ Rimuovi'}
                        </button>
                      </div>
                      {deleteStatus.storeLogoSquare.error && (
                        <div className="seller-text-danger">{deleteStatus.storeLogoSquare.error}</div>
                      )}
                    </div>
                  )}
                </div>

                {/* Logo Negozio Orizzontale */}
                <div className="seller-form-group">
                  <label className="seller-form-label">Logo Negozio Orizzontale:</label>
                  <div className="seller-file-upload">
                    <input
                      type="file"
                      className="seller-form-control"
                      name="storeLogoHorizontal"
                      accept="image/*,application/pdf"
                      onChange={handleFileChange}
                    />
                    <p style={{ margin: '8px 0 0 0', fontSize: '12px', color: '#666' }}>
                      Formati supportati: JPG, PNG, PDF. Dimensione massima: 5MB
                    </p>
                  </div>
                  {files.storeLogoHorizontal && (
                    <button
                      type="button"
                      className="seller-btn seller-btn-secondary"
                      onClick={() => uploadFile('storeLogoHorizontal')}
                      disabled={uploadStatus.storeLogoHorizontal.uploading}
                    >
                      {uploadStatus.storeLogoHorizontal.uploading ? '⏳ Caricamento...' : '📤 Carica Logo Orizzontale'}
                    </button>
                  )}
                  {uploadStatus.storeLogoHorizontal.error && (
                    <div className="seller-text-danger">{uploadStatus.storeLogoHorizontal.error}</div>
                  )}
                  {sellerInfo.storeLogoHorizontal && (
                    <div className="seller-file-preview">
                      {sellerInfo.storeLogoHorizontal.endsWith('.pdf') ? (
                        <a href={sellerInfo.storeLogoHorizontal} target="_blank" rel="noopener noreferrer" className="seller-btn seller-btn-outline">
                          📄 Visualizza Logo Orizzontale
                        </a>
                      ) : (
                        <img src={sellerInfo.storeLogoHorizontal} alt="Logo Orizzontale" />
                      )}
                      <div className="seller-file-actions">
                        <button
                          type="button"
                          className="seller-btn seller-btn-danger seller-btn-sm"
                          onClick={() => deleteFile('storeLogoHorizontal')}
                          disabled={deleteStatus.storeLogoHorizontal.deleting}
                        >
                          {deleteStatus.storeLogoHorizontal.deleting ? '⏳ Rimuovendo...' : '🗑️ Rimuovi'}
                        </button>
                      </div>
                      {deleteStatus.storeLogoHorizontal.error && (
                        <div className="seller-text-danger">{deleteStatus.storeLogoHorizontal.error}</div>
                      )}
                    </div>
                  )}
                </div>

                {/* Banner Negozio */}
                <div className="seller-form-group">
                  <label className="seller-form-label">Banner Negozio:</label>
                  <div className="seller-file-upload">
                    <input
                      type="file"
                      className="seller-form-control"
                      name="storeBanner"
                      accept="image/*,application/pdf"
                      onChange={handleFileChange}
                    />
                    <p style={{ margin: '8px 0 0 0', fontSize: '12px', color: '#666' }}>
                      Formati supportati: JPG, PNG, PDF. Dimensione massima: 5MB
                    </p>
                  </div>
                  {files.storeBanner && (
                    <button
                      type="button"
                      className="seller-btn seller-btn-secondary"
                      onClick={() => uploadFile('storeBanner')}
                      disabled={uploadStatus.storeBanner.uploading}
                    >
                      {uploadStatus.storeBanner.uploading ? '⏳ Caricamento...' : '📤 Carica Banner'}
                    </button>
                  )}
                  {uploadStatus.storeBanner.error && (
                    <div className="seller-text-danger">{uploadStatus.storeBanner.error}</div>
                  )}
                  {sellerInfo.storeBanner && (
                    <div className="seller-file-preview">
                      {sellerInfo.storeBanner.endsWith('.pdf') ? (
                        <a href={sellerInfo.storeBanner} target="_blank" rel="noopener noreferrer" className="seller-btn seller-btn-outline">
                          📄 Visualizza Banner
                        </a>
                      ) : (
                        <img src={sellerInfo.storeBanner} alt="Banner Negozio" />
                      )}
                      <div className="seller-file-actions">
                        <button
                          type="button"
                          className="seller-btn seller-btn-danger seller-btn-sm"
                          onClick={() => deleteFile('storeBanner')}
                          disabled={deleteStatus.storeBanner.deleting}
                        >
                          {deleteStatus.storeBanner.deleting ? '⏳ Rimuovendo...' : '🗑️ Rimuovi'}
                        </button>
                      </div>
                      {deleteStatus.storeBanner.error && (
                        <div className="seller-text-danger">{deleteStatus.storeBanner.error}</div>
                      )}
                    </div>
                  )}
                </div>

                <div className="seller-form-actions">
                  <button 
                    type="button" 
                    className="seller-btn seller-btn-primary" 
                    onClick={() => setEditingSection(null)}
                  >
                    Salva e Indietro
                  </button>
                </div>
              </form>
            ) : (
              <div className="seller-info-grid">
                {/* Logo Negozio Quadrato */}
                <div className="seller-info-card">
                  <div className="seller-info-label">Logo Negozio Quadrato</div>
                  <div className="seller-info-value">
                    {sellerInfo.storeLogoSquare ? (
                      sellerInfo.storeLogoSquare.endsWith('.pdf') ? (
                        <a href={sellerInfo.storeLogoSquare} target="_blank" rel="noopener noreferrer">
                          📄 Visualizza Logo Quadrato
                        </a>
                      ) : (
                        <img src={sellerInfo.storeLogoSquare} alt="Logo Quadrato" style={{ width: '100px', borderRadius: '8px' }} />
                      )
                    ) : 'N/A'}
                  </div>
                </div>

                {/* Logo Negozio Orizzontale */}
                <div className="seller-info-card">
                  <div className="seller-info-label">Logo Negozio Orizzontale</div>
                  <div className="seller-info-value">
                    {sellerInfo.storeLogoHorizontal ? (
                      sellerInfo.storeLogoHorizontal.endsWith('.pdf') ? (
                        <a href={sellerInfo.storeLogoHorizontal} target="_blank" rel="noopener noreferrer">
                          📄 Visualizza Logo Orizzontale
                        </a>
                      ) : (
                        <img src={sellerInfo.storeLogoHorizontal} alt="Logo Orizzontale" style={{ width: '150px', borderRadius: '8px' }} />
                      )
                    ) : 'N/A'}
                  </div>
                </div>

                {/* Banner Negozio */}
                <div className="seller-info-card">
                  <div className="seller-info-label">Banner Negozio</div>
                  <div className="seller-info-value">
                    {sellerInfo.storeBanner ? (
                      sellerInfo.storeBanner.endsWith('.pdf') ? (
                        <a href={sellerInfo.storeBanner} target="_blank" rel="noopener noreferrer">
                          📄 Visualizza Banner
                        </a>
                      ) : (
                        <img src={sellerInfo.storeBanner} alt="Banner Negozio" style={{ width: '100%', maxWidth: '400px', borderRadius: '8px' }} />
                      )
                    ) : 'N/A'}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

    </>
  );
}

export default SellerAccount;
